// extracted by mini-css-extract-plugin
module.exports = {"shares":"shares-3S6d1ugw","iframe":"iframe-1QlCev-i","come":"come-1M7yavA8","laiyuan":"laiyuan-2-mERC9A"};